export function generateDeviceFingerprint() {
  const components = [
    navigator.userAgent,
    navigator.language,
    new Date().getTimezoneOffset(),
    navigator.hardwareConcurrency || '',
    navigator.deviceMemory || '',
  ];

  return components.join('###');
}

export function obfuscateToken(token) {
  if (!token) return null;

  const salt = generateRandomString(16);
  let obfuscated = '';

  for (let i = 0; i < token.length; i++) {
    const charCode = token.codePointAt(i) ^ salt.codePointAt(i % salt.length);
    obfuscated += charCode.toString(16).padStart(2, '0');
  }

  return salt + '.' + obfuscated;
}

export function deobfuscateToken(obfuscatedToken) {
  if (!obfuscatedToken) return null;

  const [salt, data] = obfuscatedToken.split('.');
  let original = '';

  for (let i = 0; i < data.length; i += 2) {
    const hex = data.substr(i, 2);
    const charCode =
      Number.parseInt(hex, 16) ^ salt.codePointAt((i / 2) % salt.length);
    original += String.fromCodePoint(charCode);
  }

  return original;
}

function generateRandomString(length) {
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';

  const randomValues = new Uint8Array(length);
  window.crypto.getRandomValues(randomValues);

  for (let i = 0; i < length; i++) {
    result += characters.charAt(randomValues[i] % characters.length);
  }

  return result;
}

export function setupSecurityListeners(onSecurityViolation) {
  // Check for suspicious activity
  const checkSecurity = () => {
    const storedFingerprint = sessionStorage.getItem('device-fingerprint');
    const currentFingerprint = generateDeviceFingerprint();

    // Check if fingerprint has changed dramatically
    if (storedFingerprint && storedFingerprint !== currentFingerprint) {
      onSecurityViolation('fingerprint-mismatch');
      return false;
    }

    return true;
  };

  // Set up periodic checks
  const intervalId = setInterval(checkSecurity, 60000);

  // Check on visibility change
  document.addEventListener('visibilitychange', checkSecurity);

  // Return cleanup function
  return () => {
    clearInterval(intervalId);
    document.removeEventListener('visibilitychange', checkSecurity);
  };
}

export const secureStorage = {
  setItem: (key, value) => {
    try {
      const obfuscatedValue = obfuscateToken(value);
      sessionStorage.setItem(key, obfuscatedValue);
      return true;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error storing item securely', error);
      return false;
    }
  },

  getItem: key => {
    try {
      const obfuscatedValue = sessionStorage.getItem(key);
      return deobfuscateToken(obfuscatedValue);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error retrieving item', error);
      return null;
    }
  },

  removeItem: key => {
    try {
      sessionStorage.removeItem(key);
      return true;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error removing item', error);
      return false;
    }
  },
};
